export const GEOGRAPHICAL_SEARCH_BOUNDS: google.maps.LatLngBoundsLiteral = {
  north: 71.3,
  south: 25,
  west: -87.53,
  east: 60,
}
